import classNames from "classnames";

import { Checkbox, Typography } from "@braintrust/braintrust-ui-components";
import { useAppDispatch, useAppSelector } from "@js/hooks";
import type { EmployerBidListBid } from "@js/types/jobs";

import {
  getHiddenUnselectedBidsTotal,
  getSelectedBidIds,
} from "./bid-bulk-selection-slice";
import { useBidSelectionCheckbox } from "./use-bid-selection-checkbox";

import styles from "./style.module.scss";

type BidSelectionCheckboxProps = {
  bidList: EmployerBidListBid[];
};

export const BidSelectionCheckbox = ({
  bidList,
}: BidSelectionCheckboxProps) => {
  const dispatch = useAppDispatch();

  const selectedBidIds = useAppSelector(getSelectedBidIds);
  const bidsTotal = bidList.length;
  const selectedBidsTotal = selectedBidIds.length;
  const hiddenUnselectedBidsTotal = getHiddenUnselectedBidsTotal(
    bidList,
    selectedBidIds,
  );

  const allBidsSelected =
    bidsTotal > 0 &&
    bidsTotal - hiddenUnselectedBidsTotal === selectedBidsTotal &&
    selectedBidsTotal > 0;

  const someBidsSelected = !allBidsSelected && selectedBidsTotal > 0;
  const showLabel = selectedBidsTotal > 0;

  const label = (
    <Typography component="p" variant="paragraph" size="medium">
      <Typography component="span" fontWeight={500}>
        {selectedBidsTotal}
      </Typography>{" "}
      of{" "}
      <Typography component="span" fontWeight={500}>
        {bidsTotal}
      </Typography>{" "}
      selected
    </Typography>
  );

  const handleBulkSelection = useBidSelectionCheckbox(allBidsSelected, bidList);

  return (
    <Checkbox
      className={classNames(styles.bulkCheckbox, {
        [styles.bulkCheckboxWithLabel]: showLabel,
      })}
      label={showLabel ? label : undefined}
      checked={allBidsSelected}
      indeterminate={someBidsSelected}
      onChange={() => dispatch(handleBulkSelection())}
    />
  );
};
